import React, {useEffect, useState} from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useParams, useNavigate } from "react-router-dom";
import { getOrderById, updateOrder, resetApiStatus } from "../../slices/OrdersSlice";
import { useForm, Controller } from "react-hook-form"
import { CamelToSentanceCase, debounce } from "../../Utils/utils/CommanFnc";
import SelectBox from "../../components/admin/SelectBox"
import defaultConfig from "../../config/Config";
import { ToSelectOption } from "../../Utils/utils/CommanFnc";
import { confirm } from 'react-bootstrap-confirmation'
import { Loading } from "../../components/Loading";
import { MessageModel } from "../../components/MessageModel";
export function View() {
    const params = useParams()
    const [orderId, setOrderId] = useState(params.id)
    const [orderData, setOrderData] = useState({})
    const data = useSelector( (state) => state.orders.orderData )
    const loading = useSelector( (state) => state.orders.loading )
    const message = useSelector( (state) => state.orders.message )
    const success = useSelector( (state) => state.orders.success )
    const locationData = useLocation()
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const orderStatus = ToSelectOption(defaultConfig.orderStatusList, { value:"value", label:"label" })
    const [sumOfFullFillAmt, setSumOfFullFillAmt] = useState(0)
    const [pageName, setPageName] = useState('');
    const { 
        register, 
        handleSubmit, 
        getValues,
        setValue,
        control,
        //formState: { errors },  
    } = useForm({
        mode: "onBlur",
    })
    useEffect(() => {
        setPageName(locationData?.state.pageName.replace('/',''))
    }, [locationData?.state.pageName])
        
    useEffect( () => {
        setOrderId(params.id)
        dispatch(getOrderById(params.id))
    },[dispatch, params])

    useEffect(()=>{
        setValue('status', data?.status)
        setValue('comment', data?.comment)
        setSumOfFullFillAmt(data?.finalAmount)
        data?.product?.forEach((element, index) => {
            setValue(`finalAmount.${index}`, (parseInt(element?.fullFillQuantity || 0) * parseFloat(element?.price || 0)).toFixed(2))
            setValue(`fullFillQuantity.${index}`, element?.fullFillQuantity || 0)
            setValue(`balanceQuantity.${index}`, element?.balanceQuantity || 0 )
        });
        setOrderData(data)
    },[data, setValue])

    const changeOrderStatus = function(){
        const allFullFillQuantity =  getValues('fullFillQuantity')
        const allQty = getValues('quantity')
        const sumOfQty = allQty?.reduce((acc, currValue) => {
            return acc + (parseInt(currValue) || 0)
        }, 0)
        const sumOfFullFillQty = allFullFillQuantity?.reduce((acc, currValue) => {
            return acc + (parseInt(currValue) || 0)
        }, 0)
        let status = defaultConfig.orderStatusList[0]['value']
        if(sumOfFullFillQty > 0){
            if(sumOfFullFillQty < sumOfQty ){
                status = defaultConfig.orderStatusList[1]['value']
            }else if(sumOfFullFillQty === sumOfQty ) {
                status = defaultConfig.orderStatusList[2]['value']
            }
        }
        setValue("status",status)
    }

    const sumOfFullFill = function(event) {
        if(isNaN(event.target.value)) {
            setValue(event.target.name, ''); 
            return
        }
        const key = event.target.name.split('.')[1]
        const balanceQty = parseInt(getValues(`balanceQuantityReadOnly.${key}`)) || 0;
        const pricePerItem = getValues(`price.${key}`) || 0;
        let fullFillQuantity = parseInt(getValues(`fullFillQuantityReadOnluy.${key}`)) || 0;
        let deliveredQty = parseInt(event.target.value) || 0;
        fullFillQuantity = fullFillQuantity + deliveredQty;
        const fullFillAmt = parseFloat(fullFillQuantity * pricePerItem).toFixed(2);

        if(deliveredQty > balanceQty){
            setValue(event.target.name, balanceQty);
            deliveredQty = balanceQty;
        }else if(deliveredQty < 0) {
            setValue(event.target.name, 0);
            deliveredQty = 0;
        }
        setValue(`balanceQuantity.${key}`, (balanceQty - deliveredQty));
        setValue(`fullFillQuantity.${key}`, fullFillQuantity);
        setValue(`finalAmount.${key}`, fullFillAmt)
        const allFullFillAmt = getValues('finalAmount') || []
        const total = allFullFillAmt.reduce( (acc, currentVal) =>  {
           return parseFloat(acc) + (parseFloat(currentVal) || 0)
        }, 0 )
        setSumOfFullFillAmt(total?parseFloat(total)?.toFixed(2): 0)
        changeOrderStatus()
    }

    const onSubmit = async function(data) {
        let product = []
        data?.fullFillQuantity.forEach( (item, index) => {
            if(data?.productId[index]) {
                product.push({
                    "productId" : data?.productId[index], 
                    "name" : data?.name[index], 
                    "quantity" : data?.quantity[index], 
                    'balanceQuantity': data.balanceQuantity[index],
                    "price" : data?.price[index], 
                    "fullFillQuantity" : item,
                    'deliveredQty': data?.deliveredQuantity[index]
                });
            }
        } )
        const dataToSubmit = {
            orderId,
            comment: data?.comment,
            status: data?.status,
            finalAmount: sumOfFullFillAmt,
            product
        }
        const result = await confirm("Are you sure you want to update this order?")
        if(result) dispatch(updateOrder(dataToSubmit));        
    }
    return (
        <React.Fragment>
            <div className="row">
                <div className="col-md-6 col-lg-12">
                    <div className="card payment-card">
                        <div className="card-header">
                            <div className="row">
                                <div className="col-sm-10">
                                    <h4 className="card-title">Order Details</h4>
                                </div>
                                <div className="col-sm-2 text-right">
                                    <Link className="btn btn-primary btn-lg" to={
                                            { 
                                                pathname:`/${pageName}`,
                                                search:`page=${locationData?.state?.page}&pageLength=${locationData?.state?.pageLength}`
                                            }
                                    }><i className="fa fa-arrow-left"></i>  Back To List
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <hr/>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <input type="hidden" {...register('orderId')} value={orderId} readOnly />
                            <div className="card-body">
                                <div className="row text-center">
                                    <div className="col-sm-6">
                                        <div className="col-sm-12 border">
                                            <div className="row">
                                                <div className="col-sm-5 bg-light">
                                                    <label
                                                        className={`font-weight-bold align-middle  pt-3`}>
                                                        Order From:
                                                    </label>
                                                </div>
                                                <div className="col-sm-5">
                                                    <label className={`font-weight-bold align-middle  pt-3`}>
                                                        {CamelToSentanceCase(orderData?.orderFrom?.name)}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 border">
                                            <div className="row">
                                                <div className="col-sm-5 bg-light">
                                                    <label className={`font-weight-bold align-middle  pt-3`}> Role </label>
                                                </div>
                                                <div className="col-sm-5">
                                                    <label className={`font-weight-bold align-middle  pt-3`}>
                                                        {defaultConfig.orderUserType.find( (item) => item.value === orderData?.orderFrom?.type)?.label}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 border">
                                            <div className="row">
                                                <div className="col-sm-5 bg-light">
                                                    <label className={`font-weight-bold align-middle  pt-3`}> State </label>
                                                </div>
                                                <div className="col-sm-5">
                                                    <label className={`font-weight-bold align-middle  pt-3`}>
                                                        {CamelToSentanceCase(orderData?.orderFrom?.stateName)}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 border">
                                            <div className="row">
                                                <div className="col-sm-5 bg-light">
                                                    <label className={`font-weight-bold align-middle  pt-3`}> City </label>
                                                </div>
                                                <div className="col-sm-5">
                                                    <label className={`font-weight-bold align-middle  pt-3`}>
                                                        {CamelToSentanceCase(orderData?.orderFrom?.cityName)}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 border">
                                            <div className="row">
                                                <div className="col-sm-5 bg-light">
                                                    <label
                                                        className={`font-weight-bold align-middle  pt-3`}>
                                                        Agent:
                                                    </label>
                                                </div>
                                                <div className="col-sm-5">
                                                    <label className={`font-weight-bold align-middle  pt-3`}>{CamelToSentanceCase(orderData?.userDetail?.name)}</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 border">
                                            <div className="row">
                                                <div className="col-sm-5 bg-light">
                                                    <label
                                                        className={`font-weight-bold align-middle  pt-3`}>
                                                        Total Amount
                                                    </label>
                                                </div>
                                                <div className="col-sm-5">
                                                    <label className={`font-weight-bold align-middle  pt-3`}>{orderData?.totalAmount}</label>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div className="col-sm-12 border">
                                            <div className="row">
                                                <div className="col-sm-5 bg-light">
                                                    <label
                                                        className={`font-weight-bold align-middle  pt-3`}>
                                                        Ordered Date
                                                    </label>
                                                </div>
                                                <div className="col-sm-5">
                                                    <label className={`font-weight-bold align-middle  pt-3`}>{}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-sm-6">
                                        <div className="col-sm-12 border ml-1">
                                            <div className="row">
                                                <div className="col-sm-5 bg-light">
                                                    <label
                                                        className={`font-weight-bold align-middle pt-3`}>
                                                        <b>Order To</b>
                                                    </label>
                                                </div>
                                                <div className="col-sm-5">
                                                    <label className={`font-weight-bold align-middle  pt-3`}>{
                                                        CamelToSentanceCase(orderData?.orderTo?.name)}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 border">
                                            <div className="row">
                                                    <div className="col-sm-5 bg-light">
                                                        <label className={`font-weight-bold align-middle  pt-3`}> Role </label>
                                                    </div>
                                                    <div className="col-sm-5">
                                                        <label className={`font-weight-bold align-middle  pt-3`}>
                                                            {defaultConfig.orderUserType.find( (item) => item.value === orderData?.orderTo?.type)?.label}
                                                        </label>
                                                    </div>
                                                </div>
                                        </div>
                                        <div className="col-sm-12 border">
                                            <div className="row">
                                                <div className="col-sm-5 bg-light">
                                                    <label className={`font-weight-bold align-middle  pt-3`}> State </label>
                                                </div>
                                                <div className="col-sm-5">
                                                    <label className={`font-weight-bold align-middle  pt-3`}>
                                                        {CamelToSentanceCase(orderData?.orderTo?.stateName)}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 border">
                                            <div className="row">
                                                <div className="col-sm-5 bg-light">
                                                    <label className={`font-weight-bold align-middle  pt-3`}> City </label>
                                                </div>
                                                <div className="col-sm-5">
                                                    <label className={`font-weight-bold align-middle  pt-3`}>
                                                        {CamelToSentanceCase(orderData?.orderTo?.cityName)}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 border ml-1">
                                            <div className="row">
                                                <div className="col-sm-5 bg-light">
                                                    <label
                                                        className={`font-weight-bold align-middle  pt-3`}>
                                                        Full Fill Amount
                                                    </label>
                                                </div>
                                                <div className="col-sm-5">
                                                    <label className={`font-weight-bold align-middle  pt-3`}>{sumOfFullFillAmt}</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 border ml-1">
                                            <div className="row">
                                                <div className="col-sm-5 bg-light">
                                                    <label
                                                        className={`font-weight-bold align-middle pt-3`}>
                                                        Status
                                                    </label>
                                                </div>
                                                <div className="col-sm-7 p-0">
                                                    <Controller
                                                        name="status"
                                                        control={control}
                                                        render={({ field: { value, onChange } }) => (
                                                            <SelectBox
                                                                options={orderStatus}
                                                                isClearable={true}
                                                                isDisabled={pageName === 'my-placed-orders'}
                                                                onChange={(opt) => onChange(opt.value)}
                                                                value={orderStatus.find(
                                                                    (option) => option.value === value
                                                                )}
                                                            />
                                                        )}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 border ml-1">
                                            <div className="row">
                                                <div className="col-sm-5 bg-light">
                                                    <label
                                                        className={`font-weight-bold align-middle pt-3`}>
                                                        Comment
                                                    </label>
                                                </div>
                                                <div className="col-sm-7 p-0">
                                                    {
                                                        pageName !== 'my-placed-orders'?<textarea 
                                                                                            type="text"
                                                                                            className="input-label form-control"
                                                                                            {...register(`comment`)}  
                                                                                        ></textarea>:orderData?.comment
                                                    }
                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </div>    
                                </div>   
                            </div>
                            <div className="col-sm-12 border mt-5 p-3 table-responsive">
                                
                                    <table className="table" style={{'fontSize': '14px'}}>
                                        <thead>
                                            <tr>
                                                <th width="25%">Product</th>
                                                <th className="text-right"  width="7%">Price Per Item</th>
                                                <th className="text-right"  width="7%">Order Quantity</th>
                                                <th className="text-right"  width="7%">Balance Quantity</th>
                                                <th className="text-right"  width="7%">Full Fill Quantity</th>
                                                <th className="text-right"  width="10%">Quantity To Delivered</th>
                                                <th className="text-right"  width="10%">Final Amount</th>
                                            </tr>
                                        </thead>
                                        
                                        <tbody>
                                            {
                                                orderData?.product?.map((item, index) => {
                                                    return (
                                                        <tr scope="row" key={index}>
                                                            <td>
                                                                <input type="hidden" {...register(`productId.${index}`)} value={item.productId} />
                                                                <input className="border-0" type="hidden" {...register(`name.${index}`)} value={CamelToSentanceCase(item?.name)} />
                                                                {CamelToSentanceCase(item?.name)}
                                                            </td>
                                                            <td className="text-right">
                                                                <input className="border-0 text-center" type="hidden" {...register(`price.${index}`)} value={item?.price} />
                                                                {item?.price}
                                                            </td>
                                                            <td className="text-right" >
                                                                <input className="border-0 text-center" type="hidden" {...register(`quantity.${index}`)} value={item?.quantity} />
                                                                {item?.quantity}
                                                            </td>
                                                            <td className="text-right" >
                                                                <input className="border-0 text-center" type="hidden" {...register(`balanceQuantityReadOnly.${index}`)} value={item?.balanceQuantity} />
                                                                <input className="border-0 text-center" type="text" {...register(`balanceQuantity.${index}`)} />
                                                            </td>
                                                            <td className="text-right" >
                                                            <input className="border-0 text-center" style={ { 'width': '100px'} } type="hidden" {...register(`fullFillQuantityReadOnluy.${index}`)} value={item.fullFillQuantity} />
                                                                <input className="border-0 text-center" style={ { 'width': '100px'} } type="text" {...register(`fullFillQuantity.${index}`)} />
                                                                
                                                            </td>
                                                            <td className="text-right" >
                                                                <input 
                                                                    {...register(`deliveredQuantity.${index}`)}  
                                                                    type="text"
                                                                    min={0}
                                                                    max={item?.quantity}
                                                                    onChange={ debounce(sumOfFullFill)}
                                                                    style={ { 'width': '100px'} }
                                                                />
                                                            </td>
                                                            <td className="text-right" >
                                                                <input style={ { 'width': '70px'} } className="border-0 text-right" type="text" {...register(`finalAmount.${index}`)} readOnly />
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                            <tr>
                                                <th colSpan={6}>
                                                    Final Amount
                                                </th>
                                                <td className="text-right">{sumOfFullFillAmt}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    {
                                    pageName !== 'my-placed-orders'? <div className="col-12 mb-3 text-right">
                                            <button type="submit" className="btn btn-success btn-lg mx-2">Update Order</button>
                                        </div>:''
                                    }
                                    
                                
                                
                            </div>
                        </form>
                    </div>
                </div>
                { loading?<Loading/>:''}
                {message ? 
                    <MessageModel
                    btnEvent={ ()=>{
                        dispatch(resetApiStatus()) 
                        if(success) 
                            navigate("/orders")
                    } }
                    success={success}
                    message={message}
                    />
                :""}
            </div>
        </React.Fragment>
    )
}